import { useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";

import classes from "./dashboard.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import { LoadingMessage } from "@/components/ReactSelect/LoadingOptions";
import Fetching from "@/components/Fetching/Fetching";

const DashboardMainFilter = ({ data, isLoading, applyFilter, filters }) => {
	const [businessFilter, setBusinessFilter] = useState(filters.business_id);
	const [aptitudesFilter, setAptitudesFilter] = useState(filters.aptitudes_id);
	const [seasonFilter, setSeasonFilter] = useState(filters.season_id);
	const [initialDateFilter, setInitialDateFilter] = useState(filters.initial_date);
	const [finalDateFilter, setFinalDateFilter] = useState(filters.final_date);

	const handleCleanFilter = () => {
		applyFilter({
			businessFilter: "",
			aptitudesFilter: "",
			seasonFilter: "",
			initialDateFilter: "",
			finalDateFilter: "",
		});
	};

	const handleApplyFilter = () => {
		applyFilter({
			businessFilter: businessFilter,
			aptitudesFilter: aptitudesFilter,
			seasonFilter: seasonFilter,
			initialDateFilter: initialDateFilter,
			finalDateFilter: finalDateFilter,
		});
	};

	return (
		<Col md={3} className={classes.mainFilter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr className={classes.filterHr} />

			{isLoading ? (
				<Fetching bottomMargin={"5em"} topMargin={"5em"} />
			) : (
				<div className={classes.divContent}>
					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Razón Social</span>
						</Col>
						<Col md={12}>
							<Select
								isClearable={true}
								value={data && data.business && data.business.filter((b) => Number(b.value) === Number(businessFilter.value))}
								placeholder={<div>Seleccione</div>}
								options={data && data.business ? data.business : []}
								onChange={(value) => setBusinessFilter({ ...businessFilter, value: value ? value.value : "", label: value ? value.label : "" })}
								components={{ NoOptionsMessage, LoadingMessage }}
								menuPlacement="auto"
								isLoading={isLoading}
							/>
						</Col>
					</Row>

					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Aptitudes</span>
						</Col>
						<Col md={12}>
							<Select
								value={
									data &&
									data.aptitudes &&
									data.aptitudes.filter(
										(a) =>
											aptitudesFilter &&
											aptitudesFilter.value.length > 0 &&
											_.map(aptitudesFilter.value.split(","), Number).includes(Number(a.value)),
									)
								}
								isMulti
								placeholder={<div>Seleccione</div>}
								options={data && data.aptitudes ? data.aptitudes : []}
								onChange={(value) => {
									let baseValue = [];
									let baseLabel = [];
									value.forEach((element) => {
										baseValue.push(element.value);
										baseLabel.push(element.value + "||" + element.label);
									});

									setAptitudesFilter({
										...aptitudesFilter,
										value: baseValue.length !== 0 ? baseValue.toString() : "",
										label: baseLabel.length !== 0 ? baseLabel.toString() : "",
									});
								}}
								components={{ NoOptionsMessage, LoadingMessage }}
								menuPlacement="auto"
								isLoading={isLoading}
							/>
						</Col>
					</Row>

					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Temporada</span>
						</Col>
						<Col md={12}>
							<Select
								isClearable={true}
								value={data && data.seasons && data.seasons.filter((b) => Number(b.value) === Number(seasonFilter.value))}
								placeholder={<div>Seleccione</div>}
								options={data && data.seasons ? data.seasons : []}
								onChange={(value) => {
									setSeasonFilter({ ...seasonFilter, value: value ? value.value : "", label: value ? value.label : "" });
									setInitialDateFilter({ ...initialDateFilter, value: value.initial_date, label: value.initial_date });
									setFinalDateFilter({ ...finalDateFilter, value: value.end_date, label: value.end_date });
								}}
								components={{ NoOptionsMessage, LoadingMessage }}
								menuPlacement="auto"
								isLoading={isLoading}
							/>
						</Col>
					</Row>

					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Fecha</span>
						</Col>
						<Col md={6} style={{ paddingRight: "5px" }}>
							<small>Desde</small>
							<Form.Control
								type="text"
								name="created_at"
								placeholder=" "
								value={initialDateFilter ? initialDateFilter.value : ""}
								onChange={(e) => {
									setSeasonFilter({ ...seasonFilter, value: "", label: "" });
									setInitialDateFilter({ ...initialDateFilter, value: e.target.value, label: e.target.value });
								}}
								onFocus={(e) => (e.target.type = "date")}
								style={{ fontSize: "13px" }}
							/>
						</Col>
						<Col md={6} style={{ paddingLeft: "5px" }}>
							<small>Hasta</small>
							<Form.Control
								type="text"
								name="created_at"
								placeholder=" "
								value={finalDateFilter ? finalDateFilter.value : ""}
								onChange={(e) => {
									setSeasonFilter({ ...seasonFilter, value: "", label: "" });
									setFinalDateFilter({ ...finalDateFilter, value: e.target.value, label: e.target.value });
								}}
								onFocus={(e) => (e.target.type = "date")}
								style={{ fontSize: "13px" }}
							/>
						</Col>
					</Row>
				</div>
			)}

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default DashboardMainFilter;
